/**
 * Canonical class-merging helper.
 *
 * `clsx` composes conditional classNames; `tailwind-merge` resolves conflicting
 * Tailwind utilities (e.g. `px-4 px-6` → `px-6`). Use this anywhere you'd
 * otherwise build class strings by hand.
 *
 * Example:
 *   <div className={cn("px-4 text-sm", isActive && "bg-coach-cedar text-white")} />
 */
import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
